import { HeroSection } from "@/components/home/HeroSection";
import { StatsSection } from "@/components/home/StatsSection";
import { PrivacySection } from "@/components/home/PrivacySection";
import { FeaturesSection } from "@/components/home/FeaturesSection";
import { PricingSection } from "@/components/home/PricingSection";
import { HomeFooter } from "@/components/home/HomeFooter";
import { HumanLoopSection } from "@/components/home/HumanLoopSection";
import { TutorialVideosSection } from "@/components/home/TutorialVideosSection";

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <StatsSection />
      <div id="features">
        <FeaturesSection />
      </div>
      <div id="human-loop">
        <HumanLoopSection />
      </div>
      <div id="tutorials">
        <TutorialVideosSection />
      </div>
      <div id="privacy">
        <PrivacySection />
      </div>
      <div id="pricing">
        <PricingSection />
      </div>
      <HomeFooter />
    </div>
  );
};

export default Home;